
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/baseUI/FacesRating/FacesRating.scss.css.virtualfile';
        module.exports = {"container":"_container_1t2zw_7","icon":"_icon_1t2zw_11","selected":"_selected_1t2zw_15"};